/* Currency selector
   -----------------
   Opens the country list and submits Shopify's localization form. The form
   does the real work — this only handles opening, closing and keyboard use.
   Written so the control still submits if JS fails to load: the panel is
   hidden by an attribute the script removes, and each option is a real
   submit button. */
(function () {
  'use strict';

  function init(form) {
    var toggle = form.querySelector('[data-ccy-toggle]');
    var panel = form.querySelector('[data-ccy-panel]');
    if (!toggle || !panel) return;

    function open() {
      panel.hidden = false;
      form.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      /* keep the panel on screen when the header sits near the right edge */
      var box = panel.getBoundingClientRect();
      panel.classList.toggle('ccy__panel--left', box.right > window.innerWidth - 8);
      var current = panel.querySelector('.is-current') || panel.querySelector('.ccy__opt');
      if (current) current.focus();
    }

    function close(refocus) {
      panel.hidden = true;
      form.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (refocus) toggle.focus();
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (panel.hidden) open(); else close(false);
    });

    document.addEventListener('click', function (e) {
      if (!panel.hidden && !form.contains(e.target)) close(false);
    });

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { close(true); return; }
      if (panel.hidden) return;

      var opts = [].slice.call(panel.querySelectorAll('.ccy__opt'));
      var i = opts.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || opts[0]).focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); }
    });
  }

  function boot() {
    /* Matched by class: Liquid's {% form %} tag cannot emit a hyphenated
       data- attribute, so the class is the only hook available here. */
    var forms = document.querySelectorAll('form.ccy');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
